export default "__VITE_ASSET__CrWR5Naz__"